import React from "react";
import {Link} from "react-router-dom";
import '../App.css';



const PageNotFound = () => {
	return (
		<div className="container">
			<div>
	        	<div id="header">404 error</div>
	        	<p></p>
	        	 <div><Link to="/" id="back">(back to home)</Link></div>
	        </div>
			<img id="art2" src="https://media0.giphy.com/media/oje6kPRIef6Gk/giphy.gif?cid=6c09b952c2nwuo38caujrmrnbkw14q5mwdggn00imwz4kths&ep=v1_gifs_search&rid=giphy.gif&ct=g" alt="soot sprite crushed"/>
		</div>
	);
};

export default PageNotFound;
